import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import { AppText } from '../form';
import { handleWebBrowser, pixelDimensions } from '../../config/utils';

const NoClassesAvailable = () => (
  <View style={styles.viewBase}>
    <AppText style={styles.title}>HOJE NÃO TEM AULA AGENDADA! =)</AppText>
    <AppText style={styles.text}>SIGA NOSSAS REDES SOCIAIS PARA FICAR POR DENTRO COM NOSSAS DICAS E ORIENTAÇÕES PARA O DIA A DIA</AppText>
    <View style={styles.viewButtons}>
      <TouchableOpacity style={styles.buttonSocial} onPress={() => handleWebBrowser('https://www.facebook.com/LethsBrasil/')}>
        <FontAwesome5 name="facebook" size={pixelDimensions(6)} />
      </TouchableOpacity>
      <TouchableOpacity style={styles.buttonSocial}>
        <FontAwesome5 name="instagram" size={pixelDimensions(6)} onPress={() => handleWebBrowser('https://www.instagram.com/lethsbrasil/')} />
      </TouchableOpacity>
      <TouchableOpacity style={styles.buttonSocial}>
        <FontAwesome5 name="linkedin" size={pixelDimensions(6)} onPress={() => handleWebBrowser('https://www.linkedin.com/in/leths/')} />
      </TouchableOpacity>
    </View>
  </View>
);

const styles = StyleSheet.create({
  viewBase: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    textAlign: 'center',
    fontSize: pixelDimensions(6),
    fontFamily: 'MBold',
    marginHorizontal: pixelDimensions(4),
  },
  text: {
    textAlign: 'center',
    fontSize: pixelDimensions(4),
    marginVertical: pixelDimensions(1.5),
    marginHorizontal: pixelDimensions(4),
  },
  viewButtons: {
    flexDirection: 'row',
  },
  buttonSocial: {
    marginHorizontal: pixelDimensions(2),
  },
});
export default NoClassesAvailable;
